document.addEventListener(
    "DOMContentLoaded",
    function () {
        import("./core/details").then((module) => {
            module.init();
        });
        import("./core/accordion").then((module) => {
            module.init();
        });
        import("./core/query").then((module) => {
            module.init();
        });
        import("./core/column").then((module) => {
            module.init();
        });
    }
);
